import React from 'react';
import { Modal, Button } from 'antd';

import { WorkspaceMemberDto } from '@api/Api';

interface IDeleteMemeberModal {
  member: WorkspaceMemberDto | null | undefined;
  visible: boolean;
  handleShowDeleteMemberModal: (a: boolean) => void;
  handleDeleteMember: (id: string) => void;
}

function DeleteMemerModal({
  member,
  visible,
  handleShowDeleteMemberModal,
  handleDeleteMember
}: IDeleteMemeberModal) {
  const onFinish = async () => {
    await handleDeleteMember(member?.id || '');
    handleShowDeleteMemberModal(false);
  };

  return (
    <Modal
      visible={visible}
      footer={null}
      destroyOnClose
      centered={true}
      width={500}
      onCancel={() => handleShowDeleteMemberModal(false)}
    >
      <div className="modal_container">
        <h2
          className="modal_container__title"
          style={{ fontSize: 22, marginBottom: 12 }}
        >
          Delete member
        </h2>

        <p className="modal_container__subtitle" style={{ marginBottom: 32 }}>
          Do you want to delete this member? They will not be notified that they
          have been removed from the account.
        </p>
        <div className="modal_container__actions">
          <Button
            type="text"
            size="large"
            style={{
              marginRight: 12,
              border: 'none',
              height: 48,
              padding: '12px 19px'
            }}
            onClick={() => handleShowDeleteMemberModal(false)}
          >
            No
          </Button>
          <Button
            type="primary"
            size="large"
            onClick={onFinish}
            style={{ width: 216, height: 48, padding: '8px 15px' }}
          >
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteMemerModal;
